import { render, staticRenderFns } from "./ApplicationsPage.vue?vue&type=template&id=9bcd615e&scoped=true&"
import script from "./ApplicationsPage.vue?vue&type=script&lang=js&"
export * from "./ApplicationsPage.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationsPage.vue?vue&type=style&index=0&id=9bcd615e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcd615e",
  null
  
)

export default component.exports